import { cn } from '@/lib/utils';
import React from 'react';
// import { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form';

interface FormErrorProps extends React.HTMLAttributes<HTMLSpanElement> {
  message: string;
}

export const FormError = ({ message, className = '' }: FormErrorProps) => {
  return (
    <span
      className={cn(
        'mt-[12px] w-[80%] text-left text-xs font-normal text-primary',
        className
      )}
    >
      {message}
    </span>
  );
};
